import type { ColorConfig, ThemePalette } from "../ui/uiConfig";

const TOKENS: (keyof ThemePalette)[] = ["primary", "secondary", "brand1", "brand2", "brand3", "brand4", "brand5"];

export function normalizeColors(raw: any, fallback: ColorConfig): ColorConfig {
    if (!raw) return fallback;

    // Caso A: viene completo { defaultTheme, themes: { light, dark } }
    if (raw?.themes?.light || raw?.themes?.dark) {
        const out: ColorConfig = {
            defaultTheme: (raw.defaultTheme === "dark" ? "dark" : "light"),
            themes: {
                light: { ...fallback.themes.light, ...(raw.themes?.light ?? {}) },
                dark: { ...fallback.themes.dark, ...(raw.themes?.dark ?? {}) },
            },
        };

        // Garantía: todos los tokens presentes
        for (const k of TOKENS) {
            out.themes.light[k] = out.themes.light[k] ?? fallback.themes.light[k];
            out.themes.dark[k] = out.themes.dark[k] ?? fallback.themes.dark[k];
        }

        return out;
    }

    // Caso B: viene simple { primary, secondary, brand1?, ... }
    const simple = raw as Partial<ThemePalette>;

    const light: ThemePalette = {
        ...fallback.themes.light,
        ...simple,
    };

    // Dark “real”: invertimos primary/secondary si no nos pasaron nada específico para dark
    const dark: ThemePalette = {
        ...fallback.themes.dark,
        ...simple,
        primary: simple.secondary ?? fallback.themes.dark.primary,   // invertido
        secondary: simple.primary ?? fallback.themes.dark.secondary, // invertido
    };

    return {
        defaultTheme: fallback.defaultTheme,
        themes: { light, dark },
    };
}
